import React, {useEffect, useMemo} from 'react';
import {Popover} from "antd";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {IconSwitcher} from "../../Icons8Generator/IconSwitcher";
import {GlobalConsts} from "../../../styles/GlobalConsts";
import {Colors} from "../../../styles/Colors";
import "./styles/Alignment.scss"
import {light} from "@fortawesome/fontawesome-svg-core/import.macro";
import {isRTL} from "../../../services/i18n";

const Alignment = (props) => {
    const { onSelection, selection } = props;
    const alignmentOptions = useMemo(() => {
        return [
            {value: 'left', iconName: 'fa-align-left'},
            {value: 'center', iconName: 'fa-align-center'},
            {value: 'right', iconName: 'fa-align-right'},
        ]
    }, []);

    useEffect(() => {
        if(!selection) {
            onSelection(isRTL() ? 'right' : 'left')
        }
    }, [selection]);

    const content = () => {
        return (
            <div className={`alignments-wrapper ${isRTL() ? 'rtl' : ''}`}>
                {alignmentOptions.map(alignment => (
                    <div onClick={() => onSelection(alignment.value)} className={`align-item ${alignment.value === selection ? 'active' : ''}`} key={alignment.value}>
                        <FontAwesomeIcon icon={IconSwitcher(GlobalConsts.iconPrefix.LIGHT, alignment.iconName)} color={Colors.newDesign.mainText} fontSize={GlobalConsts.iconSize.XS}/>
                    </div>
                ))}
            </div>)
    }

    return (
        <Popover content={content()} trigger="click" arrow={false} placement={'bottom'} id={'custom-alignment-popover'}>
            <div className={'alignment-btn simple-action-button'}>
                <FontAwesomeIcon icon={IconSwitcher(GlobalConsts.iconPrefix.LIGHT, `fa-align-${selection}`)} color={Colors.newDesign.mainText} fontSize={GlobalConsts.iconSize.XS}/>
                <FontAwesomeIcon icon={light('chevron-down')} color={Colors.newDesign.mainText} fontSize={GlobalConsts.iconSize.XXS10}/>
            </div>
        </Popover>
    );
};

export default Alignment;